package com.ai.mitra.di

import com.ai.mitra.presentation.screens.chatscreen.ChatViewModel
import com.ai.mitra.presentation.screens.mainscreen.MainViewModel
import com.ai.mitra.utils.AppCoroutineDispatchers
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val viewModelModule = module {
    single<AppCoroutineDispatchers> { AppCoroutineDispatchersImpl() }
    factoryOf(::MainViewModel)
    factoryOf(::ChatViewModel)
}